<template>
    <div id="Console">
        <el-card shadow="never">
            <el-row>
                <el-col :span="16">
                    <el-button-group>
                        <el-button type="info" @click="refresh()" icon="el-icon-refresh">刷新</el-button>
                    </el-button-group>
                </el-col>
                <el-col :span="6" class="serch-input" style="float:right;">
                    <el-input placeholder="请输入类型编号" v-model="input5" class="input-with-select" clearable>
                    </el-input>
                </el-col>  
            </el-row>  
            <el-row class="con-table">
                <el-col :span="24">
                    <el-table
                        v-loading="loading"
                        element-loading-text="努力加载中"
                        element-loading-spinner="el-icon-loading"
                        :data="tableData3.filter(data => !input5 || data.typeCode.includes(input5.toUpperCase()))"
                        tooltip-effect="dark"
                        style="width: 100%"
                        max-height="367"
                        border
                        :summary-method="getSummaries"
                        show-summary
                        >
                        <el-table-column
                            label="类型编号"
                            prop="typeCode"
                            width="120"
                            header-align="center"
                            >
                        <template slot-scope="scope">{{ scope.row.typeCode }}</template>
                        </el-table-column>
                        <el-table-column
                            prop="description"
                            label="类型名称"
                            header-align="center"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="totalGeneratedQty"
                            label="已生成"
                            align="right"
                            header-align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="qty"
                            label="未确认"
                             align="right"
                            header-align="center"
                            >
                        </el-table-column>
                        <el-table-column
                        label="操作"
                        header-align="center"
                        >
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-tooltip class="item" effect="dark" content="生成券号" placement="bottom">
                                        <el-button
                                            :disabled = 'isAdd'
                                            size="mini"
                                            @click.native.prevent="addTicket(scope.$index, scope.row)"
                                        >
                                        生成
                                        </el-button>
                                    </el-tooltip>
                                    <el-button 
                                        :disabled="isDownload"
                                        size="mini"
                                        @click.native.prevent="downLoad2(scope.$index, scope.row)"
                                    >
                                    <i class="el-icon-download"></i>
                                        下载
                                    </el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<style lang="less" scoped>
    #Console{
        .serch-input{
            float:right;
        }
    }
</style>
<script>
import requestMixin from '../mixins/request'
import common from '../mixins/common'
import { debounce,getToken } from '@/env/util'

export default {
    mixins:[requestMixin,common],
    data(){
        return {
            isDownload:false,
            isAdd:false,
            tableData3: [],
            value: '',
            input5:'',
            loading: false,
        }
    },
    mounted(){
        //如果没有Token跳转Login页面
        getToken();
        //刷新列表
        this.$nextTick( ()=>{
            this.enterGetData()
            this.refreshTypes2('G');
        })
    },
    methods:{
        //下载
        downLoad2(index,rows){
            let loading = this.loadingCommon();
            let typeCode = rows.typeCode ;
            let userId = sessionStorage.getItem("userId") ;
            this.getUserIndex('findTypes',elem => elem.typeCode == typeCode).then((res) =>{
                let tableData = this.tableData3[res];
                let {typeCode , description} = tableData ;
            })
            let params = {
                act : 'dowload',
                typeCode : typeCode,
                userId
            }
            this.delType(params).then( (res) =>{
                let data = res.data;
                if ( !data || data.length <= 0 ) {
                    loading.close();
                    this.alert('请先生成新的券号，然后进行下载 !','warning')
                    return;
                }
                let url = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(data);
                let len = data.split(',').length-1 ;
                let start = data.slice(0,8);
                let downloadLink = document.createElement("a");
                downloadLink.href = url;
                downloadLink.download = `${typeCode}-${len}-${start}.csv`; 
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
                loading.close();
                this.promptMsg('下载成功','success');
            })
            
        },
        //增加券
        addTicket(index,rows){
            let typeCode = rows.typeCode ;
            let description = rows.description ;
            this.getUserIndex('findTypes',elem => elem.typeCode == typeCode).then((res) =>{
                let {description,totalGeneratedQty,typeCode} = this.tableData3[res];   
                this.$router.push({
                    path:'/ticket/addTicket',
                    query:{
                        description,
                        totalGeneratedQty,
                        typeCode
                    }
                })  
            })
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计';
                    return;
                }
                if (index === 1) {
                    sums[index] = '';
                    return;
                }
                if (index === 4) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item =>{
                    if(typeof item[column.property] == "undefined"){
                        return Number(item[column.property])
                    }else{
                        return Number(item[column.property].toString().replace(/,/g, ""))
                    }
                });
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = this.changeTree(sums[index]);
                } else {
                    sums[index] = '';
                }
            });
            return sums;
        },
        //生成下载权限
        enterGetData(){
            let treeId = JSON.parse(sessionStorage.getItem('treeId'));
            let isAdd = treeId.includes('40');
            let isDownload = treeId.includes("41");
            if(!isDownload){this.isDownload = true;}
            isAdd ? this.isAdd = false : this.isAdd = true;
        },
        //刷新
        refresh:debounce(function(){
            this.refreshTypes2('G')
        },2000)
    },
    
}
</script>
